import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import { useSelector } from "react-redux"
import { getAllRegisterDrafts } from "../../features/admin3/admin3Slice"
import PanelUyeDenetimContainer from "../../components/adminContainers/PanelUyeDenetimContainer"
import Pagination from "../../components/shared/Pagination"
import InputSelect from "../../components/shared/input/new/InputSelect"

const Container = styled.div`
  width: 100%;
  height: 100%;
  .content{
    margin: 30px;
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;

    .top-container{
      display: flex;
      justify-content: flex-end;
      margin: 15px 0;
      margin-bottom: 40px;
    }
    .titles {
        width: 100%;
        display: grid;
        grid-template-columns:1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
        gap: 15px;
        padding-inline: 10px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
        text-align: center;
        color: ${({ theme }) => theme.mainTextColor};
      }
  }
`

const statusOptions = [
  {
    id: 0,
    text: "İşlem Bekleyenler"
  },
  {
    id: 1,
    text: "Onaylananlar"
  },
  {
    id: 2,
    text: "Reddedilenler"
  },
]

const titles = ["Kayıt Tarihi", "Yetkili Adı Soyadı", "Yetkili Mail", "Yetkili Telefon No", "Firma/Koop. Adı", "Vergi No", "Lojistikçi/Kooperatif", "İşlem"]

const PanelUyeDenetim = () => {
  const dispatch = useDispatch()
  const {userDraftList, userDraftListCount} = useSelector((state) => state.admin3)

  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 50;

  const totalPages = Math.ceil(userDraftListCount / itemsPerPage);

  const [statusType, setStatusType] = useState({
    id: 0,
    text: "İşlem Bekleyenler"
  })

  const [processedItem, setProcessedItem] = useState({
    id: null,
    type: null
  })

  useEffect(() => {
    dispatch(getAllRegisterDrafts({page: currentPage, status: statusType.id}))
  }, [currentPage, statusType])


  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle title={"Panel Üye Denetim"} position="sticky" />
        <div className="content">
          <div className="top-container">
          <InputSelect data={statusType.text} setData={setStatusType} initialOptions={statusOptions} labelText={"İşlem Türü"} inputWidth={"220px"} name={"statusType"}/>
          
          </div>
          <div className="titles">
            {titles.map((item) => (
                <p>{item}</p>
            ))}
          </div>

          {
            userDraftList?.map((item) => (
              <PanelUyeDenetimContainer item={item} processedItem={processedItem} setProcessedItem={setProcessedItem} statusType={statusType}/>
            ))
          }
        </div>
        {(userDraftList && userDraftList?.length > 0) && (
          <Pagination
            totalPages={totalPages}
            handleClick={setCurrentPage}
            currentPage={currentPage}
          />
        )}

      </div>
    </Container>
  )
}

export default PanelUyeDenetim